import { FieldInputProps } from "formik";
import { FunctionComponent } from "react";

import { ReactComponent as CircleNok } from "@src/modules/shared/components/Results/icons/circle-nok.svg";
import { ReactComponent as CircleOk } from "@src/modules/shared/components/Results/icons/circle-ok.svg";
import {
  CheckboxOption,
  CheckboxWrapper,
  StyledInput,
} from "@src/modules/shared/components/Results/ResultCheckboxField/ResultCheckboxField.components";

const ResultCheckboxField: FunctionComponent<FieldInputProps<boolean>> = ({
  ...field
}) => {
  return (
    <CheckboxWrapper>
      <StyledInput
        id={field.name}
        checked={field.value}
        onChange={field.onChange}
      />
      <CheckboxOption htmlFor={field.name} isActive={!!field.value}>
        <CircleOk />
      </CheckboxOption>
      <CheckboxOption htmlFor={field.name} isActive={!field.value}>
        <CircleNok />
      </CheckboxOption>
    </CheckboxWrapper>
  );
};

export default ResultCheckboxField;
